import { NavigationState } from './contexts';

export const initialScrollPositions: NavigationState['scrollPositions'] = {
  adminAdvancePayor: 0,
  adminAdvances: 0,
  adminBulkRemove: 0,
  adminCompanyDetails: 0,
  adminCreditExposure: 0,
  adminCreditLimit: 0,
  adminCsrDashboard: 0,
  adminCsrInvoices: 0,
  adminCsrLoads: 0,
  adminDashboard: 0,
  adminFactorAssignment: 0,
  adminFactorAssignmentAudit: 0,
  adminFactorAssignmentHistory: 0,
  adminInvoicePayDateChangeReport: 0,
  adminInvoices: 0,
  adminMisdirectedPayments: 0,
  adminNoaActionConflictsHistoryList: 0,
  adminNoaActionConflictsList: 0,
  adminNoaCoachableNoasList: 0,
  adminNoaList: 0,
  adminNoaPendingFactorsList: 0,
  adminNoaSearchList: 0,
  adminNoaSplitList: 0,
  adminPayorList: 0,
  adminPendingCarrierBanks: 0,
  adminPreviousBankChanges: 0,
  adminPromotionalCampaignRelationships: 0,
  adminPromotionalCampaigns: 0,
  adminSelectCarrierClaimedRelationships: 0,
  adminSelectCarrierPotentialRelationships: 0,
  adminSelectCarriers: 0,
  adminTriumphLoadAdvancePayor: 0,
  adminTriumphLoadAdvances: 0,
  adminUnreconciledFundsPayorShow: 0,
  adminUnreconciledFundsPayors: 0,
  factorAllInvoices: 0,
  factorAllLoads: 0,
  factorInvoices: 0,
  factorLoads: 0,
  factorPayees: 0,
  factorPayments: 0,
  factorPayors: 0,
  metricAggregates: 0,
  metricHistory: 0,
  noaProcessorNoaList: 0,
  payeeInvoices: 0,
  payeePaperwork: 0,
  payeePayments: 0,
  payorBillingReport: 0,
  payorCreditLimitReport: 0,
  payorCreditNotes: 0,
  payorGotpFeesReport: 0,
  payorHeldInvoices: 0,
  payorHighwayAlerts: 0,
  payorInvoiceRefundsReport: 0,
  payorInvoiceReview: 0,
  payorInvoices: 0,
  payorLoads: 0,
  payorPaperwork: 0,
  payorPayments: 0,
  payorPreviousSettlementReport: 0,
  payorPreviousWeeklySettlementReport: 0,
  payorRelationships: 0,
  payorRevenueShareReport: 0,
  payorUnreconciledFunds: 0,
};
